"use client"

import { useCallback } from 'react'

export interface UseDarkModeReturn {
  toggle: () => void
  enable: () => void
  disable: () => void
}

/**
 * 다크모드 상태를 관리하는 훅
 * HTML 문서의 'dark' 클래스를 조작하여 다크모드를 제어합니다.
 */
export function useDarkMode(): UseDarkModeReturn {
  const toggle = useCallback(() => {
    document.documentElement.classList.toggle('dark')
  }, [])

  const enable = useCallback(() => {
    document.documentElement.classList.add('dark')
  }, [])

  const disable = useCallback(() => {
    document.documentElement.classList.remove('dark')
  }, [])

  return {
    toggle,
    enable,
    disable
  }
}